import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  confirm(event) {
    if (window.confirm(event.params.message)) {
      this.element.requestSubmit();
    } else {
      event.target.checked = !event.target.checked;
    }
  }
}
